var __accessCheck = (obj, member, msg) => {
  if (!member.has(obj))
    throw TypeError("Cannot " + msg);
};
var __privateGet = (obj, member, getter) => {
  __accessCheck(obj, member, "read from private field");
  return getter ? getter.call(obj) : member.get(obj);
};
var __privateAdd = (obj, member, value) => {
  if (member.has(obj))
    throw TypeError("Cannot add the same private member more than once");
  member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
};
var __privateSet = (obj, member, value, setter) => {
  __accessCheck(obj, member, "write to private field");
  setter ? setter.call(obj, value) : member.set(obj, value);
  return value;
};
var _formControlId, _label;
import { unsafeCSS, html } from "lit";
import { property, state } from "lit/decorators.js";
import { I18nController } from "../../utilities/i18n.js";
import { LeafElement } from "../leaf-element.js";
const styles = "/*------------------------------------*\\\n    #RESET\n\\*------------------------------------*/\n/**\n * Border-Box http:/paulirish.com/2012/box-sizing-border-box-ftw/\n */\n*,\n::slotted(*),\n*:before,\n*:after {\n  box-sizing: border-box;\n}\n\n:host *,\n:host *::before,\n:host *::after {\n  box-sizing: inherit;\n}\n\n[hidden] {\n  display: none !important;\n}\n\n.leaf-c-button--success {\n  color: var(--leaf-color-content-success);\n}\n\n.leaf-c-button--error {\n  color: var(--leaf-color-content-error);\n}\n\n:host {\n  display: block;\n  font-size: var(--leaf-font-size-1);\n  font-weight: var(--leaf-typography-label-large-font-weight);\n  margin-left: var(--leaf-spacing-4);\n  margin-top: var(--leaf-spacing-8);\n}";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
const _LeafLabel = class _LeafLabel extends LeafElement {
  constructor() {
    super(...arguments);
    /** The actual form control id this label links to. */
    __privateAdd(this, _formControlId, void 0);
    /** The label instance in the light DOM. */
    __privateAdd(this, _label, void 0);
    this.i18nController = new I18nController(this);
    this.formControl = null;
  }
  connectedCallback() {
    super.connectedCallback();
    this.addEventListener("click", this.focusOnFormControl);
    window.addEventListener("leaf:form-element-update", () => this.requestUpdate("for"));
  }
  willUpdate(changes) {
    var _a, _b, _c, _d;
    super.willUpdate(changes);
    if (changes.has("for")) {
      if (this.for) {
        this.formControl = (_a = this.getRootNode()) == null ? void 0 : _a.querySelector(
          `#${this.for}`
        );
        this.optional = !((_b = this.formControl) == null ? void 0 : _b.hasAttribute("required"));
        __privateSet(this, _formControlId, `${this.for}-leaf`);
        (_c = __privateGet(this, _label)) == null ? void 0 : _c.setAttribute("for", __privateGet(this, _formControlId));
      } else {
        (_d = __privateGet(this, _label)) == null ? void 0 : _d.removeAttribute("for");
        this.formControl = null;
      }
    }
  }
  render() {
    return html`
      <slot @slotchange=${this.onSlotchange} style="display: none"></slot>
      <slot name="label"></slot>
      ${this.optional ? html`<span class="optional">(${this.i18nController.term("optional")})</span>` : ""}
    `;
  }
  onSlotchange({ target }) {
    const nodes = target.assignedNodes({ flatten: true });
    if (__privateGet(this, _label) && nodes.length) {
      __privateGet(this, _label).innerHTML = "";
      __privateGet(this, _label).append(...nodes);
    } else {
      __privateSet(this, _label, __privateGet(this, _label) ?? (this.querySelector('label[slot="label"]') || document.createElement("label")));
      __privateGet(this, _label).htmlFor = __privateGet(this, _formControlId) ?? "";
      __privateGet(this, _label).slot = "label";
      __privateGet(this, _label).append(...nodes);
      this.append(__privateGet(this, _label));
    }
  }
  focusOnFormControl() {
    var _a;
    if ((_a = this.formControl) == null ? void 0 : _a.formControlElement) {
      this.formControl.formControlElement.focus();
    }
  }
};
_formControlId = new WeakMap();
_label = new WeakMap();
_LeafLabel.styles = unsafeCSS(styles);
let LeafLabel = _LeafLabel;
__decorateClass([
  property()
], LeafLabel.prototype, "for", 2);
__decorateClass([
  state()
], LeafLabel.prototype, "formControl", 2);
__decorateClass([
  property({ type: Boolean })
], LeafLabel.prototype, "optional", 2);
__decorateClass([
  property({ type: Boolean, reflect: true })
], LeafLabel.prototype, "disabled", 2);
export {
  LeafLabel
};
//# sourceMappingURL=label.component.js.map
